import React from 'react';
import { IconButton, Tooltip } from '@chakra-ui/react';
import { FiBarChart2 } from 'react-icons/fi';

interface AnalyticsIconProps {
  tooltip?: string;
  onClick?: () => void;
}

export const AnalyticsIcon: React.FC<AnalyticsIconProps> = ({
  tooltip = 'Ver estatísticas',
  onClick,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onClick) {
      onClick();
    }
  };

  return (
    <Tooltip label={tooltip} placement="top">
      <IconButton
        aria-label="Estatísticas"
        icon={<FiBarChart2 size={18} />}
        size="sm"
        colorScheme="blue"
        variant="ghost"
        onClick={handleClick}
        _hover={{ bg: 'blue.50' }}
      />
    </Tooltip>
  );
};
